import * as React from 'react';
import { useLayoutEffect, useRef } from 'react';
import { useGetList } from 'react-admin';
import logos from '../../assets/business/logo';
// eslint-disable-next-line no-unused-vars
import styles from '../../css/styles.css';

const Offer = ({ offer }) => {
	const offerRef = useRef();
	useLayoutEffect(
		() => { offerRef.current.innerHTML = offer.full || offer.short; },
	);
	return (
		<div ref={offerRef} className="business-offer" />
	);
};

const Phones = ({ phones }) => {
	if (!phones) {
		return <div />;
	}
	return (
		<div>
			{phones.map((p) => (<div key={p.show}><a href={`tel:${p.dial}`}>{p.show}</a></div>))}
		</div>
	);
};

const Emails = ({ emails }) => {
	if (!emails) {
		return <div />;
	}
	return (
		<div>
			{
				emails.map((p) => (
					<div key={p.address}>
						<a className="business-email" href={`mailTo:${p.address}`}>{p.address}</a>
					</div>
				))
			}
		</div>
	);
};

const Contacts = ({
	address, phones, emails, site,
}) => {
	return (
		<div className="business-contacts-container">
			{
				address
					? <div>{address.show}</div>
					: <div />
			}
			<Phones phones={phones} />
			<Emails emails={emails} />
			{
				site
					? <div><a href={site.go}>{site.show}</a></div>
					: <div />
			}
		</div>
	);
};

const POS = ({ pos }) => {
	if (!pos) {
		return null;
	}
	return (
		pos.map((p) => (
			<Contacts
				key={`${p.address.show}, ${p.site?.go}, ${p.phones?.length && p.phones[0].dial}`}
				address={p.address}
				site={p.site}
				emails={p.emails}
				phones={p.phones}
			/>
		)));
};

const BusinessCard = ({ data }) => {
	return (
		<div className="business-card">
			<div className="business-logo-container">
				{
					data.logoFile
						? <img alt="" className="business-logo" src={data.logoFile.src} />
						: <img alt="" className="business-logo" src={logos[data.logo]?.svg || logos[data.logo]?.png} />
				}
				<div>
					<div className="business-title">
						{data.title.short}
					</div>
					<div className="business-second-title">
						{data.title.occupation}
					</div>
					<Offer offer={data.offer} />
				</div>
			</div>
			<Contacts
				address={data.address}
				site={data.site}
				emails={data.emails}
				phones={data.phones}
			/>
			<POS pos={data.pos} />
		</div>
	);
};

const PrintableBusiness = () => {
	const CATALOG_STATUS_SUSPENDED = 'suspended';

	const { data, isLoading } = useGetList(
		'Business',
		{
			pagination: { page: 1, perPage: 1000 },
			filter: {
				catalogStatus: { $ne: CATALOG_STATUS_SUSPENDED },
				mainVersion: { $exists: false },
			},
			sort: { field: 'title.short', order: 'ASC' },
		},
	);

	if (isLoading) {
		return null;
	}
	return (
		<div className="business-card-list">
			{data.map((r) => <BusinessCard data={r} key={r.id} />)}
		</div>
	);
};

export default PrintableBusiness;
